import { useRef, useState, useCallback, useEffect } from "react";

type FormatCommand =
  | "bold"
  | "italic"
  | "underline"
  | "strikeThrough"
  | "justifyLeft"
  | "justifyCenter"
  | "justifyRight"
  | "insertUnorderedList"
  | "insertOrderedList";

// ─── SVG Icons ─────────────────────────────────────────────────────────────────

const IconBold = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z" />
  </svg>
);
const IconItalic = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z" />
  </svg>
);
const IconUnderline = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M6 4v7a6 6 0 0 0 12 0V4h-2v7a4 4 0 0 1-8 0V4H6zm-1 16h14v2H5v-2z" />
  </svg>
);
const IconStrike = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M3 12h18v2H3v-2zm7.19-2.4C9.5 9.18 9 8.45 9 7.5 9 6.12 10.12 5 11.5 5c1.09 0 2.01.66 2.37 1.6l1.86-.7C15.05 4.04 13.39 3 11.5 3 9.01 3 7 5.01 7 7.5c0 1.34.57 2.54 1.47 3.4L10.19 9.6zM11.5 13c.74.32 2 .93 2 2.5 0 1.38-1.12 2.5-2.5 2.5-1.21 0-2.24-.86-2.46-2l-1.96.4C6.96 18.37 9.07 20 11.5 20c2.49 0 4.5-2.01 4.5-4.5 0-2-1.22-3.26-2.57-3.9L11.5 13z" />
  </svg>
);
const IconAlignLeft = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M3 5h18v2H3V5zm0 4h12v2H3V9zm0 4h18v2H3v-2zm0 4h12v2H3v-2z" />
  </svg>
);
const IconAlignCenter = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M3 5h18v2H3V5zm3 4h12v2H6V9zm-3 4h18v2H3v-2zm3 4h12v2H6v-2z" />
  </svg>
);
const IconAlignRight = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M3 5h18v2H3V5zm6 4h12v2H9V9zm-6 4h18v2H3v-2zm6 4h12v2H9v-2z" />
  </svg>
);
const IconUL = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M4 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3-1h14v2H7V5zm-3 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3-1h14v2H7v-2zm-3 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3-1h14v2H7v-2z" />
  </svg>
);
const IconOL = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-8v2h14V3H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z" />
  </svg>
);
const IconLink = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
);
const IconUndo = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M12.5 8c-2.65 0-5.05 1-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z" />
  </svg>
);
const IconRedo = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M18.4 10.6C16.55 9 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z" />
  </svg>
);
const IconClear = () => (
  <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor">
    <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12 1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z" />
  </svg>
);

// ─── Color Palette ─────────────────────────────────────────────────────────────

const COLORS = [
  "#000000", "#222222", "#444444", "#666666", "#888888", "#aaaaaa", "#cccccc", "#ffffff",
  "#ff0000", "#ff4400", "#ff8800", "#ffcc00", "#ffff00", "#88ff00", "#00ff00", "#00ff88",
  "#00ffff", "#0088ff", "#0000ff", "#4400ff", "#8800ff", "#cc00ff", "#ff00ff", "#ff0088",
  "#ff9999", "#ffbb99", "#ffdd99", "#ffff99", "#bbff99", "#99ffdd", "#99ffff", "#99bbff",
  "#9999ff", "#bb99ff", "#ff99ff", "#ff99bb", "#cc0000", "#cc4400", "#cc8800", "#ccaa00",
  "#88cc00", "#00cc44", "#00ccaa", "#0088cc", "#0000cc", "#4400cc", "#8800cc", "#cc00aa",
  "#660000", "#663300", "#664400", "#665500", "#446600", "#006633", "#006666", "#003366",
  "#000066", "#220066", "#440066", "#660055",
];

const TRANSPARENT_ICON = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10'%3E%3Crect width='5' height='5' fill='%23ccc'/%3E%3Crect x='5' y='5' width='5' height='5' fill='%23ccc'/%3E%3Crect x='5' width='5' height='5' fill='%23fff'/%3E%3Crect y='5' width='5' height='5' fill='%23fff'/%3E%3C/svg%3E")`;

interface ColorPaletteProps {
  onSelect: (color: string | null) => void;
  onClose: () => void;
  showTransparent?: boolean;
}

function ColorPalette({ onSelect, onClose, showTransparent }: ColorPaletteProps) {
  return (
    <div
      className="absolute left-0 z-50 mt-1 p-2.5 rounded-xl border border-white/15 shadow-2xl"
      style={{ background: "#1a1d2e", top: "100%" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="grid gap-1" style={{ gridTemplateColumns: "repeat(8, 1fr)" }}>
        {showTransparent && (
          <button
            onMouseDown={(e) => { e.preventDefault(); onSelect(null); onClose(); }}
            className="w-5 h-5 rounded border border-white/30 hover:scale-125 transition-transform hover:border-white/60 relative overflow-hidden"
            style={{ backgroundImage: TRANSPARENT_ICON }}
            title="Trong suốt"
          >
            <span className="absolute inset-0 flex items-center justify-center">
              <span className="block w-[18px] h-[1.5px] bg-red-500 rotate-45 rounded" />
            </span>
          </button>
        )}
        {COLORS.map((color) => (
          <button
            key={color}
            onMouseDown={(e) => { e.preventDefault(); onSelect(color); onClose(); }}
            className="w-5 h-5 rounded border border-white/10 hover:scale-125 transition-transform hover:border-white/40"
            style={{ backgroundColor: color }}
            title={color}
          />
        ))}
      </div>
      <div className="mt-2.5 pt-2 border-t border-white/10 flex items-center gap-2">
        <span className="text-gray-400 text-xs">Màu tùy chỉnh:</span>
        <input
          type="color"
          onChange={(e) => { onSelect(e.target.value); onClose(); }}
          className="w-8 h-6 rounded cursor-pointer border border-white/10 bg-transparent"
        />
      </div>
    </div>
  );
}

// ─── ToolbarButton ─────────────────────────────────────────────────────────────

interface ToolbarButtonProps {
  onClick: () => void;
  title: string;
  active?: boolean;
  children: React.ReactNode;
}

function ToolbarButton({ onClick, title, active, children }: ToolbarButtonProps) {
  return (
    <div className="relative group">
      <button
        onMouseDown={(e) => { e.preventDefault(); onClick(); }}
        className={`w-7 h-7 flex items-center justify-center rounded transition-colors
          ${active ? "bg-blue-500 text-white" : "hover:bg-white/10 text-gray-300"}`}
      >
        {children}
      </button>
      <div className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 hidden group-hover:block z-[100]">
        <div className="bg-gray-900 text-white text-[11px] whitespace-nowrap px-2 py-1 rounded shadow-lg border border-white/10">
          {title}
        </div>
        <div className="w-2 h-2 bg-gray-900 border-r border-b border-white/10 rotate-45 mx-auto -mt-1" />
      </div>
    </div>
  );
}

const Divider = () => <div className="w-px h-5 bg-white/15 mx-0.5 shrink-0" />;

// ─── TextEditor ────────────────────────────────────────────────────────────────

export interface TextEditorProps {
  placeholder?: string;
  minHeight?: string;
  initialValue?: string;
  isLoading?: boolean;
  isSaving?: boolean;
  onSave?: (html: string) => void | Promise<void>;
  onCancel?: () => void;
}

const FONTS = [
  { label: "Mặc định", value: "inherit" },
  { label: "Arial", value: "Arial" },
  { label: "Georgia", value: "Georgia" },
  { label: "Courier New", value: "'Courier New'" },
  { label: "Times New Roman", value: "'Times New Roman'" },
  { label: "Verdana", value: "Verdana" },
  { label: "Trebuchet MS", value: "'Trebuchet MS'" },
  { label: "Palatino", value: "Palatino" },
  { label: "Garamond", value: "Garamond" },
  { label: "Comic Sans MS", value: "'Comic Sans MS'" },
  { label: "Impact", value: "Impact" },
  { label: "Tahoma", value: "Tahoma" },
  { label: "Lucida Console", value: "'Lucida Console'" },
  { label: "Gill Sans", value: "'Gill Sans'" },
  { label: "Century Gothic", value: "'Century Gothic'" },
  { label: "Candara", value: "Candara" },
  { label: "Franklin Gothic", value: "'Franklin Gothic Medium'" },
  { label: "Bookman Old Style", value: "'Bookman Old Style'" },
  { label: "Copperplate", value: "Copperplate" },
  { label: "Optima", value: "Optima" },
];

function saveSelection(): Range | null {
  const sel = window.getSelection();
  if (sel && sel.rangeCount > 0) return sel.getRangeAt(0).cloneRange();
  return null;
}

function restoreSelection(range: Range | null) {
  if (!range) return;
  const sel = window.getSelection();
  if (sel) {
    sel.removeAllRanges();
    sel.addRange(range);
  }
}

export function TextEditor({
  placeholder = "Nhập nội dung tại đây...",
  minHeight = "200px",
  initialValue,
  isLoading = false,
  isSaving = false,
  onSave,
  onCancel,
}: TextEditorProps) {
  const editorRef = useRef<HTMLDivElement>(null);
  const fontColorRef = useRef<HTMLDivElement>(null);
  const bgColorRef = useRef<HTMLDivElement>(null);
  const fontSizeInputRef = useRef<HTMLInputElement>(null);
  const savedRangeRef = useRef<Range | null>(null);

  const [activeFormats, setActiveFormats] = useState<Set<string>>(new Set());
  const [fontSize, setFontSize] = useState("16");
  const [fontFamily, setFontFamily] = useState("inherit");
  const [fontColor, setFontColor] = useState("#ffffff");
  const [bgColor, setBgColor] = useState<string | null>(null);
  const [showFontColorPalette, setShowFontColorPalette] = useState(false);
  const [showBgColorPalette, setShowBgColorPalette] = useState(false);

  useEffect(() => {
    if (editorRef.current && initialValue !== undefined) {
      editorRef.current.innerHTML = initialValue;
    }
  }, [initialValue]);

  useEffect(() => {
    const handleMouseDown = (e: MouseEvent) => {
      const target = e.target as Node;
      if (fontColorRef.current && !fontColorRef.current.contains(target)) {
        setShowFontColorPalette(false);
      }
      if (bgColorRef.current && !bgColorRef.current.contains(target)) {
        setShowBgColorPalette(false);
      }
    };
    document.addEventListener("mousedown", handleMouseDown);
    return () => document.removeEventListener("mousedown", handleMouseDown);
  }, []);

  const updateActiveFormats = useCallback(() => {
    const formats = new Set<string>();
    (["bold", "italic", "underline", "strikeThrough"] as FormatCommand[]).forEach((cmd) => {
      if (document.queryCommandState(cmd)) formats.add(cmd);
    });
    setActiveFormats(formats);
    // Lưu selection mỗi khi caret thay đổi trong editor
    savedRangeRef.current = saveSelection();
  }, []);

  const execFormat = useCallback((command: FormatCommand) => {
    editorRef.current?.focus();
    if (command === "insertUnorderedList" || command === "insertOrderedList") {
      document.execCommand("styleWithCSS", false, "false");
    }
    document.execCommand(command, false);
    updateActiveFormats();
  }, [updateActiveFormats]);

  const execFormatWithValue = useCallback((command: string, value: string) => {
    document.execCommand(command, false, value);
    editorRef.current?.focus();
  }, []);

  /**
   * Apply font size lên vùng bôi đen.
   *
   * Dùng execCommand('fontSize', '7') làm sentinel:
   *   - Browser tự wrap selection trong <font size="7"> (hoạt động với mọi loại selection)
   *   - Ta tìm các <font size="7"> đó và replace bằng <span style="font-size: Xpx">
   *
   * Đây là cách TinyMCE / Quill / CKEditor dùng — đáng tin cậy nhất.
   */
  const applyFontSize = useCallback((size: string) => {
    const num = parseInt(size);
    if (!num || num < 1) return;

    // Restore selection đã lưu lúc editor blur
    restoreSelection(savedRangeRef.current);

    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return;
    if (!editorRef.current) return;

    const range = sel.getRangeAt(0);

    // Tạo span với font-size px chính xác — KHÔNG dùng execCommand('fontSize')
    // vì execCommand chỉ nhận giá trị 1-7 (HTML font size), không phải px
    const span = document.createElement("span");
    span.style.fontSize = `${num}px`;

    try {
      // surroundContents hoạt động khi selection không cắt ngang tag boundaries
      range.surroundContents(span);
    } catch {
      // Khi selection cắt ngang nhiều element (ví dụ: một phần bold, một phần không)
      // → extractContents an toàn hơn
      const fragment = range.extractContents();
      span.appendChild(fragment);
      range.insertNode(span);
    }

    // Xóa font-size trên các element con để tránh override (nest vô tận)
    span.querySelectorAll<HTMLElement>("[style*='font-size']").forEach((el) => {
      el.style.fontSize = "";
      if (!el.getAttribute("style")?.trim()) el.removeAttribute("style");
    });

    // Restore selection quanh span vừa tạo
    const newRange = document.createRange();
    newRange.selectNodeContents(span);
    sel.removeAllRanges();
    sel.addRange(newRange);
    savedRangeRef.current = newRange.cloneRange();

    editorRef.current.focus();
  }, []);

  // Hàm wrap selection trong span với style cho trước
  // Dùng pure DOM thay vì execCommand để tránh browser bỏ qua màu trắng / màu đặc biệt
  const applyStyleToSelection = useCallback((styleProp: string, value: string) => {
    restoreSelection(savedRangeRef.current);
    const sel = window.getSelection();
    if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return;

    const range = sel.getRangeAt(0);
    const span = document.createElement("span");
    (span.style as any)[styleProp] = value;

    try {
      range.surroundContents(span);
    } catch {
      const fragment = range.extractContents();
      span.appendChild(fragment);
      range.insertNode(span);
    }

    // Xóa style trùng trên các element con để tránh conflict
    span.querySelectorAll<HTMLElement>(`[style*='${styleProp === "color" ? "color" : "background"}']`).forEach((el) => {
      if (el !== span) {
        (el.style as any)[styleProp] = "";
        if (!el.getAttribute("style")?.trim()) el.removeAttribute("style");
      }
    });

    const newRange = document.createRange();
    newRange.selectNodeContents(span);
    sel.removeAllRanges();
    sel.addRange(newRange);
    savedRangeRef.current = newRange.cloneRange();
    editorRef.current?.focus();
  }, []);

  const applyFontColor = (color: string | null) => {
    if (!color) return;
    setFontColor(color);
    applyStyleToSelection("color", color);
  };

  const applyBgColor = (color: string | null) => {
    setBgColor(color);
    if (color) {
      applyStyleToSelection("backgroundColor", color);
    } else {
      applyStyleToSelection("backgroundColor", "transparent");
    }
  };

  const handleSave = () => {
    if (!onSave || !editorRef.current) return;
    onSave(editorRef.current.innerHTML);
  };

  const handleCancel = () => {
    if (editorRef.current) {
      editorRef.current.innerHTML = initialValue ?? "";
    }
    onCancel?.();
  };

  return (
    <>
      <style>{`
        [data-editor] ul { list-style-type: disc; padding-left: 1.5rem; margin: 4px 0; }
        [data-editor] ol { list-style-type: decimal; padding-left: 1.5rem; margin: 4px 0; }
        [data-editor] li { margin: 2px 0; }
        [data-editor]:empty:before { content: attr(data-placeholder); color: #6b7280; pointer-events: none; }
      `}</style>

      <div
        className="rounded-xl overflow-visible border border-white/10"
        style={{ background: "rgba(255,255,255,0.04)" }}
      >
        {/* Toolbar */}
        {/* onMouseDown prevent default ở đây giúp TOÀN BỘ toolbar không steal focus
            khỏi editor — selection/blur của editor được giữ nguyên */}
        <div
          className="flex flex-wrap items-center gap-0.5 p-2 border-b border-white/10"
          style={{ background: "rgba(255,255,255,0.03)" }}
        >
          {/* Font Family */}
          <select
            value={fontFamily}
            onMouseDown={(e) => e.stopPropagation()}
            onChange={(e) => {
              setFontFamily(e.target.value);
              execFormatWithValue("fontName", e.target.value);
            }}
            className="h-7 px-1.5 rounded bg-white/10 text-gray-300 text-xs border border-white/10 focus:outline-none focus:border-blue-400"
            style={{ maxWidth: 140 }}
          >
            {FONTS.map((f) => (
              <option key={f.value} value={f.value}>{f.label}</option>
            ))}
          </select>

          {/* Font Size */}
          <div className="flex items-center h-7 rounded border border-white/10 bg-white/10 overflow-hidden">
            <input
              type="number"
              min={8}
              max={200}
              value={fontSize}
              // Toolbar đã preventDefault toàn bộ → input KHÔNG bị focus tự động
              // onMouseDown riêng: preventDefault để không bubble lên toolbar (đã có),
              // sau đó focus thủ công để người dùng gõ được
              onMouseDown={() => {
                // mousedown xảy ra TRƯỚC blur → lưu selection kịp thời
                savedRangeRef.current = saveSelection();
              }}
              onChange={(e) => {
                setFontSize(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  applyFontSize(fontSize);
                  // Sau apply, trả focus về editor
                  editorRef.current?.focus();
                }
              }}
              onBlur={(e) => {
                // Apply khi input mất focus (người dùng click vào editor hoặc nơi khác)
                applyFontSize(e.target.value);
              }}
              ref={fontSizeInputRef}
              className="w-10 h-full bg-transparent text-gray-300 text-xs text-center focus:outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            />
            <span className="text-gray-500 text-xs pr-1.5 select-none">px</span>
          </div>

          <Divider />

          <ToolbarButton onClick={() => execFormat("bold")} title="In đậm (Ctrl+B)" active={activeFormats.has("bold")}><IconBold /></ToolbarButton>
          <ToolbarButton onClick={() => execFormat("italic")} title="In nghiêng (Ctrl+I)" active={activeFormats.has("italic")}><IconItalic /></ToolbarButton>
          <ToolbarButton onClick={() => execFormat("underline")} title="Gạch chân (Ctrl+U)" active={activeFormats.has("underline")}><IconUnderline /></ToolbarButton>
          <ToolbarButton onClick={() => execFormat("strikeThrough")} title="Gạch ngang" active={activeFormats.has("strikeThrough")}><IconStrike /></ToolbarButton>

          <Divider />

          <ToolbarButton onClick={() => execFormat("justifyLeft")} title="Căn trái"><IconAlignLeft /></ToolbarButton>
          <ToolbarButton onClick={() => execFormat("justifyCenter")} title="Căn giữa"><IconAlignCenter /></ToolbarButton>
          <ToolbarButton onClick={() => execFormat("justifyRight")} title="Căn phải"><IconAlignRight /></ToolbarButton>

          <Divider />

          <ToolbarButton onClick={() => execFormat("insertUnorderedList")} title="Danh sách không thứ tự"><IconUL /></ToolbarButton>
          <ToolbarButton onClick={() => execFormat("insertOrderedList")} title="Danh sách có thứ tự"><IconOL /></ToolbarButton>

          <Divider />

          {/* Font Color */}
          <div className="relative" ref={fontColorRef}>
            <div className="relative group">
              <button
                onMouseDown={(e) => {
                  e.preventDefault();
                  setShowBgColorPalette(false);
                  setShowFontColorPalette((v) => !v);
                }}
                className="w-7 h-7 flex flex-col items-center justify-center rounded hover:bg-white/10 gap-[2px]"
              >
                <span className="text-xs font-bold text-gray-200 leading-none">A</span>
                <span className="w-4 h-[3px] rounded-sm" style={{ backgroundColor: fontColor }} />
              </button>
              <div className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 hidden group-hover:block z-[100]">
                <div className="bg-gray-900 text-white text-[11px] whitespace-nowrap px-2 py-1 rounded shadow-lg border border-white/10">Màu chữ</div>
                <div className="w-2 h-2 bg-gray-900 border-r border-b border-white/10 rotate-45 mx-auto -mt-1" />
              </div>
            </div>
            {showFontColorPalette && (
              <ColorPalette onSelect={applyFontColor} onClose={() => setShowFontColorPalette(false)} />
            )}
          </div>

          {/* Background Color */}
          <div className="relative" ref={bgColorRef}>
            <div className="relative group">
              <button
                onMouseDown={(e) => {
                  e.preventDefault();
                  setShowFontColorPalette(false);
                  setShowBgColorPalette((v) => !v);
                }}
                className="w-7 h-7 flex flex-col items-center justify-center rounded hover:bg-white/10 gap-[2px]"
              >
                <span className="text-xs font-bold text-gray-200 leading-none">H</span>
                <span
                  className="w-4 h-[3px] rounded-sm border border-white/20"
                  style={bgColor ? { backgroundColor: bgColor } : { backgroundImage: TRANSPARENT_ICON, backgroundSize: "6px 6px" }}
                />
              </button>
              <div className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 hidden group-hover:block z-[100]">
                <div className="bg-gray-900 text-white text-[11px] whitespace-nowrap px-2 py-1 rounded shadow-lg border border-white/10">Màu nền chữ</div>
                <div className="w-2 h-2 bg-gray-900 border-r border-b border-white/10 rotate-45 mx-auto -mt-1" />
              </div>
            </div>
            {showBgColorPalette && (
              <ColorPalette
                onSelect={applyBgColor}
                onClose={() => setShowBgColorPalette(false)}
                showTransparent
              />
            )}
          </div>

          <Divider />

          <ToolbarButton onClick={() => { const url = prompt("Nhập URL:"); if (url) execFormatWithValue("createLink", url); }} title="Chèn liên kết"><IconLink /></ToolbarButton>
          <ToolbarButton onClick={() => { document.execCommand("undo"); editorRef.current?.focus(); }} title="Hoàn tác (Ctrl+Z)"><IconUndo /></ToolbarButton>
          <ToolbarButton onClick={() => { document.execCommand("redo"); editorRef.current?.focus(); }} title="Làm lại (Ctrl+Y)"><IconRedo /></ToolbarButton>
          <ToolbarButton onClick={() => { document.execCommand("removeFormat"); editorRef.current?.focus(); }} title="Xóa định dạng"><IconClear /></ToolbarButton>
        </div>

        {/* Editor area */}
        {isLoading ? (
          <div className="p-4 flex items-center gap-3 text-gray-400" style={{ minHeight }}>
            <svg className="animate-spin" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
            </svg>
            <span className="text-sm">Đang tải dữ liệu...</span>
          </div>
        ) : (
          <div
            ref={editorRef}
            contentEditable
            suppressContentEditableWarning
            onKeyUp={updateActiveFormats}
            onMouseUp={updateActiveFormats}
            onSelect={updateActiveFormats}
            onBlur={() => {
              // Lưu selection ngay khi editor blur — đây là thời điểm selection vẫn còn
              savedRangeRef.current = saveSelection();
            }}
            data-editor
            data-placeholder={placeholder}
            className="p-4 text-white focus:outline-none leading-relaxed
              [&_ul]:list-disc [&_ul]:pl-6 [&_ul]:my-1
              [&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:my-1
              [&_li]:my-0.5"
            style={{ minHeight }}
          />
        )}

        {/* Footer */}
        {(onSave || onCancel) && (
          <div className="flex items-center justify-end gap-2 px-3 py-2 border-t border-white/10" style={{ background: "rgba(255,255,255,0.02)" }}>
            {onCancel && (
              <button
                onClick={handleCancel}
                disabled={isSaving}
                className="px-4 py-1.5 rounded-lg text-sm text-gray-300 border border-white/15 hover:bg-white/10 transition-colors disabled:opacity-50"
              >
                Huỷ
              </button>
            )}
            {onSave && (
              <button
                onClick={handleSave}
                disabled={isSaving || isLoading}
                className="px-4 py-1.5 rounded-lg text-sm text-white bg-blue-600 hover:bg-blue-500 transition-colors disabled:opacity-50 flex items-center gap-1.5"
              >
                {isSaving && (
                  <svg className="animate-spin" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83" />
                  </svg>
                )}
                {isSaving ? "Đang lưu..." : "Lưu"}
              </button>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default TextEditor;